import React, { createContext, useContext, useState } from 'react';

const TeamContext = createContext();

export const TeamProvider = ({ children, initialTeam, handleSaveTeamDetails }) => {
  const [team, setTeam] = useState(initialTeam || '');

  const saveTeamDetails = (theTeam) => {
    // Call the external save handler
    handleSaveTeamDetails(theTeam);
    
    setTeam(theTeam);
  };

  return (
    <TeamContext.Provider value={{ team, saveTeamDetails }}>
      {children}
    </TeamContext.Provider>
  );
};

export const useTeam = () => useContext(TeamContext);
